import React from "react";
import PropTypes from "prop-types";
import Toggle from "react-toggle";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ContractStatusSelect from "../../common/ContractStatusSelect";
import DropdownSearch from "../../common/DropdownSearch";

import * as codeActions from "../../../actions/codeActions";

import ReportFilters from "../ReportFiltersComponent";

const PrepaidDeferredRevenueBalanceFilters = ({
  onChange,
  fetchData,
  filters,
  handleResetFilters,
  loading,
  onExportClick,
  onPDFExport,
  exportDisabled,
  codes
}) => {
  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      ?.filter((code) => code.entity === entity && code.field === field)
      ?.map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, [(option) => option.label.toLowerCase()]);
  };

  return (
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title="Prepaid Deferred Revenue Balance"
      loading={loading}
      csvExportAvailable
      pdfExportAvailable
      onCSVExport={onExportClick}
      onPDFExport={onPDFExport}
      exportDisabled={loading || exportDisabled}
    >
      <Row>
        <Col md={3}>
          <ContractStatusSelect
            label="Contract Status"
            placeholder="Select"
            value={filters.contract_status || null}
            isMulti
            onChange={onChange("contract_status")}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            isMulti
            rowStyles={{ marginTop: 0 }}
            label="Call Status"
            placeholder="Select"
            name="call_status"
            onChange={(name, value) => onChange("call_status")(value || [])}
            value={filters.call_status || null}
            data={[...generateCodeOptions("Call", "status")]}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            End Date
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            onChange={(e) => onChange("end_date")(e.target.value)}
            value={filters.end_date}
          />
        </Col>
        <Col md={3}>
          <label
            htmlFor="balance"
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            Include negative balance
          </label>
          <div style={{ marginTop: 10 }}>
            <Toggle
              id="balance"
              onChange={(e) =>
                onChange("show_negative_balance")(e.target.checked)
              }
              checked={filters.show_negative_balance}
              value={filters.show_negative_balance}
            />
          </div>
        </Col>
      </Row>
    </ReportFilters>
  );
};

PrepaidDeferredRevenueBalanceFilters.propTypes = {
  onChange: PropTypes.func,
  filters: PropTypes.object,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  onPDFExport: PropTypes.func,
  exportDisabled: PropTypes.bool,
  codes: PropTypes.array
};

PrepaidDeferredRevenueBalanceFilters.defaultProps = {
  codes: []
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(PrepaidDeferredRevenueBalanceFilters);
